import {
  AppBar,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import PageTitle from "../../../components/PageTitle/PageTitle";
import useStyles from "../../../themes/style";
import { IoMdPerson } from "react-icons/io";
import { FaBuilding, FaCertificate, FaFileAlt, FaRegHandshake } from "react-icons/fa";
import { RiBillFill } from "react-icons/ri";
import { BsBank2, BsClipboard2Check } from "react-icons/bs";
import {
  IoCalendarNumber,
  IoDocumentsSharp,
  IoExitOutline,
  IoLogOutOutline,
} from "react-icons/io5";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { useNotification } from "../../../hooks/useNotification";
import moment from "moment";
import axios from "axios";
import CloseIcon from "@material-ui/icons/Close";
import { useHistory, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import PersonalDetails from "./userInfo/PersonalDetails";
import OfficeDetails from "./userInfo/OfficeDetails";
import ContractDetails from "./userInfo/ContractDetails";
import KYCDetails from "./userInfo/KYCDetails";
import LeaveBalanceDetails from "./userInfo/LeaveBalanceDetails";
import { MdPayment } from "react-icons/md";
import { HiComputerDesktop } from "react-icons/hi2";
import { BankLoanIcon } from "../../../components/svg/AdminUserTabIcon";
import SeparationDetails from "./userInfo/SeparationDetails";
import FinalSettlement from "./userInfo/FinalSettlement";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{ padding: "14px 0px" }}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const getMuiTheme = () =>
  createTheme({
    overrides: {
      MuiTab: {
        root: {
          "&.Mui-selected": {
            background: "none",
          },
          "&": {
            minWidth: "18%",
          },
        },
      },
    },
  });

const AdminUserInfo = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  const userId = new URLSearchParams(location.search).get("userId");
  const fullName = new URLSearchParams(location.search).get("fullName");

  const adminTitlePaths = [
    "send-payslip",
    "certificate",
    "attendance-monitor",
    "tax-documents",
    "assets",
    "loans",
  ];
  const tabConfig = [
    {
      label: "Personal Details",
      icon: <IoMdPerson size={20} />,
      path: `/app/emp-info?userId=${userId}&tab=0`,
      hasTabPanel: true,
    },
    {
      label: "Office Details",
      icon: <FaBuilding size={20} />,
      path: `/app/emp-info?userId=${userId}&tab=1`,
      hasTabPanel: true,
    },
    {
      label: "Contract Details",
      icon: <FaFileAlt size={20} />,
      path: `/app/emp-info?userId=${userId}&tab=2`,
      hasTabPanel: true,
    },
    {
      label: "KYC Details",
      icon: <BsBank2 size={20} />,
      path: `/app/emp-info?userId=${userId}&tab=3`,
      hasTabPanel: true,
    },
    {
      label: "Payslip Details",
      icon: <MdPayment size={20} />,
      path: `/app/emp-info/send-payslip?userId=${userId}&tab=4`,
      hasTabPanel: false,
    },
    {
      label: "Appreciations",
      icon: <FaCertificate size={20} />,
      path: `/app/emp-info/certificate?userId=${userId}&tab=5`,
      hasTabPanel: false,
    },
    {
      label: "Leave Balance",
      icon: <IoCalendarNumber size={20} />,
      path: `/app/emp-info?userId=${userId}&tab=6`,
      hasTabPanel: false,
    },
    {
      label: "Login Monitor",
      icon: <HiComputerDesktop size={20} />,
      path: `/app/emp-info/attendance-monitor?userId=${userId}&tab=7`,
      hasTabPanel: false,
    },
    {
      label: "Tax Documents",
      icon: <IoDocumentsSharp size={20} />,
      path: `/app/emp-info/tax-documents?userId=${userId}&tab=8`,
      hasTabPanel: false,
    },
    {
      label: "Assets",
      icon: <BsClipboard2Check size={20} />,
      path: `/app/emp-info/assets?userId=${userId}&tab=9`,
      hasTabPanel: false,
    },
    {
      label: "Loan",
      icon: <BankLoanIcon size={20} />,
      path: `/app/emp-info/loans?userId=${userId}&tab=10`,
      hasTabPanel: false,
    },
    {
      label: "Separation",
      icon: <IoExitOutline size={20} />,
      path: `/app/emp-info?userId=${userId}&tab=11`,
      hasTabPanel: true,
    },
    {
      label: "Final Settlement",
      icon: <FaRegHandshake size={20} />,
      path: `/app/emp-info?userId=${userId}&tab=12`,
      hasTabPanel: false,
    },
  ];

  const activeTabIndex = adminTitlePaths.findIndex((path) =>
    pathname.includes(path),
  );
  const [userDetails, setUserDetails] = useState({});
  const [tabValue, setTabValue] = React.useState(0);
  const [leavebalanceDetails, setLeaveBalanceDetails] = useState({});
  const [loader, setLoader] = useState(false);
  const token = localStorage.getItem("token");
  const handleNotificationCall = useNotification();
  const [confimationOpen, setConfimationOpen] = useState(false);

  const handleConfirmationModalOpen = () => {
    setConfimationOpen(true);
  };

  const handleConfirmationModalClose = () => {
    setConfimationOpen(false);
  };

  const handleTabChange = (event, newValue) => {
    const selectedTab = tabConfig[newValue];
    setTabValue(newValue);
    if (selectedTab?.path) {
      history.push(selectedTab.path);
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = parseInt(params.get("tab"));

    if (!isNaN(tab)) {
      setTabValue(tab);
    } else {
      setTabValue(0); // Default to the first tab if no tab is specified
    }
  }, [location.search]);

  async function fetchProfileData() {
    setLoader(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}employee/getUserEmployee?userId=${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );
      setLoader(false);
      if (response.data.status) {
        const data = response.data.data;
        const leave_balance_data = response.data.data?.leave_balance;
        setUserDetails(data);
        setLeaveBalanceDetails(leave_balance_data);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.log("Error Fetch Profile Data", error);
    }
  }

  async function handleEmployeeSeparation() {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}employee/triggerSeperation`,
        {
          userId: userId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );
      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        fetchProfileData();
        handleConfirmationModalClose();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.log("Error Fetch Profile Data", error);
    }
  }
  const handleUpdate = () => {
    fetchProfileData();
  };

  return (
    <div>
      <Box display="flex" flexDirection="column" gridGap={5}>
        <List
          className={classes.root}
          style={{
            backgroundImage:
              "linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%)",
            borderRadius: "8px 8px 0 0",
          }}
        >
          <ListItem alignItems="flex-start" style={{ gap: "30px" }}>
            <ListItemAvatar style={{ marginTop: "14px" }}>
              <Avatar
                style={{
                  width: "60px",
                  height: "60px",
                }}
              />
            </ListItemAvatar>
            <ListItemText
              primary={
                <React.Fragment>
                  <PageTitle
                    title={
                      (userDetails.employee &&
                        `${userDetails.employee.firstName} ${userDetails.employee.lastName}`) ||
                      (userDetails.recruiter &&
                        `${userDetails.recruiter.firstName} ${userDetails.recruiter.lastName}`) ||
                      "-"
                    }
                  />
                </React.Fragment>
              }
              secondary={
                <Box
                  component="span"
                  display="flex"
                  flexDirection="column"
                  gridGap={5}
                >
                  <Box component="span">
                    {userDetails.employee
                      ? userDetails.employee?.personalEmail
                      : userDetails.recruiter
                      ? userDetails.recruiter.personalEmail
                      : "-"}
                  </Box>
                  <Box component="span">
                    {userDetails.employee
                      ? userDetails.employee?.mobile
                      : userDetails.recruiter
                      ? userDetails.recruiter.mobile
                      : "-"}
                  </Box>
                </Box>
              }
            />
          </ListItem>
        </List>
      </Box>

      <AppBar
        position="static"
        style={{
          background: "linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%)",
          border: "2px solid #EEEEEE",
          borderRadius: "0 0 8px 8px",
          boxShadow: "rgba(0, 0, 0, 0.04) 0px 3px 5px",
          zIndex: 1,
        }}
      >
        <MuiThemeProvider theme={getMuiTheme()}>
          <Tabs
            value={tabValue}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className={classes.userInfoTabList}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: {
                backgroundColor: "#064be2",
                height: "2px",
                borderRadius: "8px",
                zIndex: 0,
              },
            }}
          >
            {tabConfig.map((tab, index) => (
              <Tab key={index} label={tab.label} icon={tab.icon} />
            ))}
          </Tabs>
        </MuiThemeProvider>
      </AppBar>

      <TabPanel value={tabValue} index={0}>
        <PersonalDetails userDetails={userDetails} onUpdate={handleUpdate} />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <OfficeDetails userDetails={userDetails} onUpdate={handleUpdate} />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <ContractDetails userDetails={userDetails} onUpdate={handleUpdate} />
      </TabPanel>
      <TabPanel value={tabValue} index={3}>
        <KYCDetails userDetails={userDetails} onUpdate={handleUpdate} />
      </TabPanel>
      <TabPanel value={tabValue} index={6}>
        <LeaveBalanceDetails leavebalanceDetails={leavebalanceDetails} />
      </TabPanel>
      <TabPanel value={tabValue} index={11}>
        <SeparationDetails userDetails={userDetails} onUpdate={handleUpdate}/>
      </TabPanel>
      <TabPanel value={tabValue} index={12}>
        <FinalSettlement userDetails={userDetails} onUpdate={handleUpdate} />
      </TabPanel>

      {/* 
      {tabConfig.map((tab, index) =>
        tab.hasTabPanel ? (
          <TabPanel key={index} value={tabValue} index={index}></TabPanel>
        ) : null,
      )} */}

      <Dialog
        onClose={handleConfirmationModalClose}
        aria-labelledby="dialog-title"
        open={confimationOpen}
        width="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          <div className={classes.center}>
            <Typography
              variant="subtitle2"
              className={classes.digColor + " " + classes.digCenter}
            >
              Confirmation
            </Typography>

            <div className={classes.drawerClose}>
              <CloseIcon
                className={classes.digClose}
                onClick={handleConfirmationModalClose}
                size="14px"
              />
            </div>
          </div>
        </DialogTitle>

        <DialogContent className={classes.chatListBackGround}>
          <Typography variant="subtitle2">
            Do you really wish to separate this employee from the organization?
          </Typography>
          <div className={classes.sendWhatsapp}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleEmployeeSeparation}
            >
              Yes
            </Button>

            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={handleConfirmationModalClose}
            >
              No
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default AdminUserInfo;
